import { makeActionHandler } from "./_reducerUtils";

export const implantationReducer = {
  initialState: {
    implantationModule: {
      phaseOne: [],
      phaseTwo: [],
      phaseThree: [],
      phaseFour: [],
      isLoaded: false
    }
  },
  handlers: {
    "implantation/SET_IMPLANTATION_MODULE":
      makeActionHandler("implantationModule"),
    "RESET_ALL": () => implantationReducer.initialState
  }
};

export default implantationReducer;
